<template>
  <div class="card raised" v-on:click="playItem">
    <div class="card-image">
      <img class="img rounded" :src="this.coverImgSrc">
    </div>
    <div class="card-body">
      <h5 class="card-title"><span>{{this.item.title}}</span></h5>
      <!-- <button v-on:click="playItem" class="btn btn-round btn-primary">Play</button> -->
    </div>
  </div>
</template>
<script>
  export default {
    name: 'videoCard',
    props: {
      trackIndex: String,
      itemIndex: Number,
      item: Object,
    },
    mounted() {
      //console.log(this.item)
    },
    computed: {
      coverImgSrc: function() {
        if (this.item.snapshots.length > 1) {
          return this.item.snapshots[1].download
        } else {
          return this.item.snapshots[0].download
        }
      },
    },
    methods: {
      playItem() {
        this.$store.dispatch('playItem', [this.trackIndex, this.itemIndex])
      }
    },

  }
</script>
<style>
.card {
  cursor: pointer;
  margin-bottom: 0 !important;
}
</style>
